import React from "react";
import { EsBadge } from "./EsBadge";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ListChecks, AlertTriangle, ShieldAlert } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const ChecklistOggiBox = ({ className = "" }) => {
  const { selectedStructure, structures = [], can } = useAuth();
  const nav = useNavigate();
  const allStruct = selectedStructure === "all";
  const structOf = (id) => structures.find((s) => s.id === id) || {};
  const { data: cl = { pazienti: [], tot_da_fare: 0, tot_scadute_obbl: 0 } } = useQuery({
    queryKey: ["checklist-oggi-box", selectedStructure],
    queryFn: async () => { try { return (await api.get("/infettive/checklist/oggi", { params: { structure_id: selectedStructure } })).data; } catch { return { pazienti: [], tot_da_fare: 0, tot_scadute_obbl: 0 }; } },
    refetchInterval: 30000,
    enabled: can("infettive"),
  });
  const conDaFare = (cl.pazienti || []).filter((p) => p.da_fare > 0 || (p.righe || []).some((r) => r.stato === "motivo"));
  const motivoDi = (p) => (p.righe || []).filter((r) => r.stato === "motivo").length;
  const totMotivo = (cl.pazienti || []).reduce((s, p) => s + motivoDi(p), 0);
  return (
    <div className={`gr-card p-5 ${className}`} data-testid="checklist-oggi-card">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-head font-bold flex items-center gap-2"><ListChecks size={18} className="text-indigo-600" /> Check-list sanitaria da completare</h2>
        <div className="flex items-center gap-2 shrink-0">
          {totMotivo > 0 && <span className="text-[11px] font-bold rounded-full px-2 py-0.5 bg-amber-100 text-amber-800" data-testid="checklist-oggi-motivo">{totMotivo} non fatte con motivazione</span>}
          {cl.tot_scadute_obbl > 0 && <span className="text-[11px] font-bold rounded-full px-2 py-0.5 bg-red-100 text-red-700 inline-flex items-center gap-1" data-testid="checklist-oggi-scadute"><AlertTriangle size={12} /> {cl.tot_scadute_obbl} in ritardo</span>}
          <button onClick={() => nav("/check-list-sanitaria")} className="text-xs font-semibold text-primary" data-testid="checklist-oggi-link">Apri →</button>
          <span className={`text-xs font-bold rounded-full px-2 py-0.5 tabnum ${cl.tot_scadute_obbl > 0 ? "bg-red-600 text-white" : cl.tot_da_fare ? "bg-indigo-100 text-indigo-700" : "bg-secondary text-muted-foreground"}`} data-testid="checklist-oggi-count">{cl.tot_da_fare}</span>
        </div>
      </div>
      {conDaFare.length === 0 ? (
        <div className="text-sm text-muted-foreground">Nessun controllo da completare oggi.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-[304px] overflow-y-auto pr-1" data-testid="checklist-oggi-list">
          {conDaFare.map((p) => (
            <button key={p.ospite_id} onClick={() => nav("/check-list-sanitaria")} data-testid={`checklist-oggi-${p.ospite_id}`}
              className={`w-full flex items-center justify-between gap-2 text-sm rounded-lg border px-3 py-2 text-left transition-colors ${p.scadute_obbl > 0 ? "bg-red-50 border-red-300 hover:bg-red-100" : "bg-indigo-50 border-indigo-200 hover:bg-indigo-100"}`}>
              <span className="font-semibold truncate flex items-center gap-1.5">
                {p.scadute_obbl > 0 ? <AlertTriangle size={13} className="text-red-600 shrink-0" /> : <ShieldAlert size={13} className="text-red-400 shrink-0" />}
                {p.cognome} {p.nome}<EsBadge id={p.ospite_id} />{allStruct ? <span className="text-xs text-muted-foreground font-normal"> · {structOf(p.structure_id).nome || ""}</span> : ""}
              </span>
              <span className="text-[11px] font-bold shrink-0 tabnum">
                {p.scadute_obbl > 0 && <span className="text-red-700 mr-1">{p.scadute_obbl} in ritardo</span>}
                {motivoDi(p) > 0 && <span className="text-amber-700 mr-1">{motivoDi(p)} con motivazione</span>}
                <span className="text-muted-foreground">{p.fatte}/{p.tot}</span>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
